import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/customers/AuthProvider";
import * as Config from "../config/config";

const PrivateRoute = () => {
  const customer = useAuth();
  if (!customer.token) return <Navigate to={Config.REDIRECT_PAGE_NOT_LOGGED_IN} />;
  return <Outlet />;
};

export default PrivateRoute;